import Image from "next/image";
import { useMemo } from "react";

import DefaultAvatar from "@/assets/images/general/default-avatar.png";
import { UrlUtils } from "@/util/url.utils";

const useMediaRender = (videoUrl: string | null | undefined, fallbackImage?: string) => {
  const renderedMedia = useMemo(() => {
    if (videoUrl && (videoUrl.includes("youtube") || videoUrl.includes("youtu.be"))) {
      const videoId = UrlUtils.getVideoIdFromUrl(videoUrl, "youtube");
      return (
        <iframe
          className="absolute inset-0 h-full w-full t:rounded-button-rounding"
          title="YouTube video player"
          allow="autoplay"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&loop=0&controls=1&modestbranding=0&rel=0&iv_load_policy=3&playsinline=1`}
        />
      );
    }

    if (videoUrl && videoUrl.includes("vimeo")) {
      const videoId = UrlUtils.getVideoIdFromUrl(videoUrl, "vimeo");
      return (
        <iframe
          src={`https://player.vimeo.com/video/${videoId}`}
          title="Vimeo video player"
          allow="autoplay; fullscreen; picture-in-picture"
          style={{ width: "100%", height: "100%" }}
          allowFullScreen
        />
      );
    }

    return (
      <Image
        src={fallbackImage || DefaultAvatar.src}
        alt="fallback image"
        className="object-cover"
        fill
      />
    );
  }, [videoUrl, fallbackImage]);

  return renderedMedia;
};

export default useMediaRender;
